export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client && to.path === '/districts') {
    const { isMobile } = useDevice();

    if (!isMobile) {
      return navigateTo('/', { replace: true });
    }
  }
});
